import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from '../../../../../../forms/validators';

@Component({
    selector: 'app-edit-dialog-mandataire',
    templateUrl: './edit-dialog-mandataire.component.html',
    styleUrls: ['./edit-dialog-mandataire.component.css'],
})
export class EditDialogMandataireComponent implements OnInit {
    t: any;
    form: FormGroup;

    constructor(
        private dialogRef: MatDialogRef<EditDialogMandataireComponent,
            { data: any }>,
        private cdref: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) data: { t: any }
    ) {
        this.t = data;
    }

    get currentDate() {
        return new Date();
    }

    getFormControl(key: string): FormControl {
        return this.form.controls[key] as FormControl;
    }

    ngOnInit(): void {

        this.form = new FormGroup({
            indRegNo: new FormControl(this.t.indRegNo, [
                Validators.required,
                !this.t?.etranger ? CustomValidators.isCin() : Validators.nullValidator,
            ]),
            staffNm: new FormControl(this.t.staffNm, [Validators.required]),
            telNo: new FormControl(this.t.telNo, [Validators.required]),
            // faxNo: new FormControl(this.t.faxNo, [Validators.required]),
            faxNo: new FormControl(this.t.faxNo),
            mtelNo: new FormControl(this.t.mtelNo, [Validators.required]),
            email: new FormControl(this.t.email, [
                Validators.required,
                CustomValidators.emailValidator(),
            ]),
            positionNm: new FormControl(this.t.positionNm, [Validators.required]),
            issuedYmd: new FormControl(this.t.issuedYmd, [Validators.required]),
        });
    }

    onSuccessAdd() {
        if (this.form.valid) {
            const data = this.form.getRawValue();

            this.dialogRef.close({
                data: data,
            });
        }
    }
}
